<template>
  <div class="cpt-bot-manage scroll-item-wrapper">
    <div class="title">机器人 管理</div>
    <div class="add-bot-btn flex-center" @click="toAddBot" v-if="show_bots.length">
      <i class="iconfont icon-add-bold"></i>
      <span>添加机器人</span>
    </div>
    <div class="module" :class="{'no-bot-module': !show_bots.length}">
      <div class="bot-list" v-if="show_bots.length">
        <div
          class="bot-item"
          v-for="bot in show_bots"
          :key="bot.bot_account_info.user_id"
          @click="handleBotAction('edit', bot, $event)"
        >
          <ChatImg
            class="bot-item-avatar"
            :src="bot.bot_account_info.avatar"
            :webp_quality="30"
            :thumbnail="`80x`"
          />
          <div class="bot-item-info">
            <div class="bot-item-header">
              <div class="bot-item-icon" v-if='bot?.display_setting?.icon && bot.display_setting.icon.length > 0' >
                <ChatImg 
                  v-tooltip="{ text: bot.display_setting.icon[0]?.desc || '' }"
                  :src="bot.display_setting.icon[0]?.icon"
                  :webp_quality="50" :thumbnail="`48x`" />
              </div>
              <div class="bot-item-name">{{ bot.bot_account_info.nickname }}</div>
              <template v-if="bot?.display_setting?.categories && bot.display_setting.categories.length > 0" >
                <div 
                  class="bot-item-tag" 
                  v-for="category of bot.display_setting.categories" :key="category.id"
                >
                  {{ category.name }}
                </div>
              </template>
            </div>
            <div class="bot-item-desc" v-if="bot.creator || bot.joined_time">
              {{ calcUserName(bot.creator) }}
              {{ bot.creator && bot.joined_time ? ' · ' : ''}}
              {{ bot.joined_time ? IMTimeFormat(bot.joined_time) + ' 邀请' : '' }}
            </div>
          </div>
          <div class="bot-item-action">
            <div class="bot-item-action-btn edit-btn" @click="handleBotAction('edit', bot, $event)">
              <i class="iconfont icon-write"></i>
            </div>
            <div class="bot-item-action-btn" @click.stop="handleBotAction('delete', bot, $event)">
              <i class="iconfont icon-more"></i>
            </div>
          </div>
        </div>
      </div>
      <template v-else>
        <div class="no-bot-text">暂无机器人</div>
        <div class="add-bot-btn flex-center" @click="toAddBot">
          <i class="iconfont icon-add-bold"></i>
          <span>添加机器人</span>
        </div>
      </template>
      
    </div>
    <div class="module mt-[20px] px-[20px] py-[24px] rounded-[5px] bg-fl-2 flex-items-center">
      <ChatImg
        class="mr-[20px] !w-[136px] !h-[112px]"
        :src="'https://imgheybox.max-c.com/oa/2024/08/22/58e5dbc3a8d59c0ec248d98d6afb8aa7.png'"
      />
      <div>
        <div class="overflow-hidden text-tx-1 text-[14px] font-bold leading-[18px]">机器人开发平台</div>
        <div class="mt-[6px] text-tx-3 text-[12px] leading-[16px]">打造实用功能，让你的房间更强大</div>
        <div class="mt-[20px] px-[14px] h-[32px] rounded-[4px] bg-bd-fl text-wh-0 pointer inline-flex items-center justify-center" @click="toBotManager">
          <span class="mr-[6px] text-[14px] leading-[18px]">创建机器人</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.66699 14.3346C2.56242 14.3346 1.66699 13.4392 1.66699 12.3346V3.66797C1.66699 2.5634 2.56242 1.66797 3.66699 1.66797H6.33366C6.70185 1.66797 7.00033 1.96645 7.00033 2.33464C7.00033 2.70282 6.70185 3.0013 6.33366 3.0013H3.66699C3.2988 3.0013 3.00033 3.29978 3.00033 3.66797V12.3346C3.00033 12.7028 3.2988 13.0013 3.66699 13.0013H12.3337C12.7018 13.0013 13.0003 12.7028 13.0003 12.3346V9.66797C13.0003 9.29978 13.2988 9.0013 13.667 9.0013C14.0352 9.0013 14.3337 9.29978 14.3337 9.66797V12.3346C14.3337 13.4392 13.4382 14.3346 12.3337 14.3346H3.66699ZM13.667 1.66797C14.0352 1.66797 14.3337 1.96645 14.3337 2.33464V6.0013C14.3337 6.36949 14.0352 6.66797 13.667 6.66797C13.2988 6.66797 13.0003 6.36949 13.0003 6.0013V3.84167L6.78211 9.49459C6.50967 9.74227 6.08804 9.72219 5.84037 9.44975C5.59269 9.17731 5.61277 8.75568 5.88521 8.50801L11.9426 3.0013H10.0003C9.63214 3.0013 9.33366 2.70283 9.33366 2.33464C9.33366 1.96645 9.63214 1.66797 10.0003 1.66797H13.667Z" fill="white"/>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import EventBus from '_lib/EventBus';
import { deepCopy, IMTimeFormat } from '_lib/utils/utils';
import { kickOutFromRoom } from "_api/channel";
import { getWebToken } from "_api/account";
import { getApplyState } from "_api/bot";
import { calcUserName } from '_lib/CalcUserInfo';
import { BOT_TYPES } from '_lib/constants/bot'
import { USER_APPLY_TYPE } from "_lib/constants/bot";
import ChatImg from "@/views/room/IM/MessageList/components/common/ChatImg";
export default {
  props: ['form'],
  mounted () {
    EventBus.$on('DeleteBot', this.deleteBot)
  },
  beforeDestroy () {
    EventBus.$off('DeleteBot', this.deleteBot)
  },
  computed: {
    show_bots () {
      return this.cur_room_bots.filter(bot => bot.bot_account_info.user_id !== BOT_TYPES.official)
    },
    ...mapGetters(['cur_room_data', 'cur_room_bots', 'user_info'])
  },
  methods: {
    handleBotAction (action, bot, event) {
      if (action === 'edit') {
        EventBus.$dynamic('BotEditDialog', deepCopy(bot))
      } else if (action === 'delete') {
        this.deleteBot(event, bot.bot_account_info.user_id)
      }
    },
    async deleteBot (event, bot_id, cb) {
      this.$contextmenu({
        groups: [{
          items: [
            {
              component: 'menu-button',
              data: {
                label: '从房间移除',
                type: 'warn'
              },
              onClick: async () => {
                this.$query({
                  config: {
                    title: '确定从房间移除该机器人吗?',
                    desc: '该操作不可取消',
                    confirm: {
                      text: '移除',
                      type: 'alert'
                    },
                    cancel: {
                      text: '取消',
                    },
                  },
                  confirmCB: () => {
                    this.confirmRemove(bot_id, cb)
                  },
                })
                
              }
            },
          ]
        }],
        event,
      })
    },
    async confirmRemove (bot_id, cb) {
      const { data } = await kickOutFromRoom({ room_id: this.form.room.room_id }, {
        room_id: this.form.room.room_id,
        to_user_id: bot_id
      })
      if (data.status == "ok") {
        this.$toast.success('操作成功')
        this.SET_CUR_ROOM_WHOLE_DATA_KEY({
          key: 'bot_infos',
          value: this.cur_room_bots.filter(bot => bot.bot_account_info.user_id !== bot_id)
        })
        cb && cb()
      }
    },
    async toBotManager () {
      if (this.lock) return
      const url = process.env.IS_PROD ? 'https://bot.xiaoheihe.cn/' : 'https://bot.debugmode.cn/'
      this.lock = true
      let res = await getApplyState(this.user_info.heybox_id)
      if(res.data.status !== "ok" || !res.data.result || res.data.result.state !== 1) {
        this.toApply(res.data.result)
        this.lock = false
        return
      }
      getWebToken({_notip: 1}).then(({ data }) => {
        if (data.status === 'ok') {
          const token = data.result.token
          window.open(url + (token ? `?web_token=${token}` : ''))
        }
      }).catch(() => {
        window.open(url)
      }).finally(() => {
        this.lock = false
      })
    },
    toApply (data) {
      if(data.state === undefined) {
        window.open(`https://${!process.env.IS_PROD ? 'open.debugmode.cn' : 'open.xiaoheihe.cn'}/zh_cn/chat_robot/auth/index`)
      } else {
        window.open(`https://${!process.env.IS_PROD ? 'open.debugmode.cn' : 'open.xiaoheihe.cn'}/zh_cn/${USER_APPLY_TYPE[data.user_type]}`)
      }
    },
    toAddBot () {
      EventBus.$emit('show-dynamic-component', 'room-settings', false)
      this.$nextTick(() => {
        this.$router.push('/app/?tab=BotPlatform')
      })
    },
    IMTimeFormat: IMTimeFormat,
    calcUserName,
    ...mapMutations(['SET_CUR_ROOM_WHOLE_DATA_KEY'])
  }
};
</script>
<style lang="scss">
.cpt-bot-manage {
  & > .add-bot-btn {
    margin: 0 0 20px 0 !important;
  }
  .add-bot-btn {
    margin: 0 auto;
    width: 121px;
    border-radius: 4px;
    background: $d-bd-fl;
    padding: 0 14px;
    height: 32px;
    color: $ct-wh-0;
    cursor: pointer;
    .iconfont {
      margin-right: 6px;
      font-size: 16px;
    }
    span {
      font-size: 14px;
      font-weight: 400;
      line-height: 18px;
      letter-spacing: 0.14px; 
    }
  }
  .module {
    &.no-bot-module {
      padding: 46px 0;
      background: $d-fl-2;
      border-radius: 5px;
    }
    .bot-list {
      max-height: 380px;
      padding: 8px 0 8px 8px;
      overflow-y: scroll;
      border-radius: 5px;
      background: $d-fl-2;
      .bot-item {
        margin-bottom: 2px;
        height: 66px;
        padding: 0 4px;
        display: flex;
        align-items: center;
        border-radius: 5px;
        cursor: pointer;
        transition: background 0.2s;
        &:hover {
          background: $d-op-2;
          .edit-btn {
            opacity: 1 !important;
          }
        }
        .bot-item-avatar {
          margin-right: 8px;
          width: 40px;
          height: 40px;
          border-radius: 50%;
        }
        .bot-item-info {
          flex: 1;
          width: 0;
          margin-right: 8px;
          .bot-item-header {
            display: flex;
            align-items: center;
            margin-bottom: 4px;

            .bot-item-icon {
              width: 16px;
              height: 16px;
              margin-right: 6px;

              .cpt-chat-img {
                width: 16px;
                height: 16px;
              }
            }

            .bot-item-name {
              color: $d-tx-2;
              font-size: 12px;
              font-weight: 700;
              line-height: 16px;
              letter-spacing: 0.12px;
            }

            .bot-item-tag {
              background: $d-op-1;
              font-size: 12px;
              font-weight: 400;
              line-height: 16px;
              letter-spacing: 0.01em;
              text-align: center;
              color: $d-op-4;
              padding: 1px 7px;
              border-radius: 2px;
              margin-left: 6px;
            }
          }
          .bot-item-desc {
            margin-top: 4px;
            color: $d-tx-3;
            font-size: 12px;
            font-weight: 400;
            line-height: 16px;
          }
        }
        .bot-item-action {
          display: flex;
          align-items: center;
          .bot-item-action-btn {
            margin-left: 4px;
            width: 24px;
            height: 24px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            border-radius: 3px;
            &.edit-btn {
              opacity: 0;
            }
            &:hover {
              background: $d-op-2;
            }
            .iconfont {
              font-size: 16px;
              color: $d-tx-3;
            }
          }
        }
      }
    }
    .no-bot-text {
      margin-bottom: 20px;
      color: $d-tx-3;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      text-align: center;
      border-radius: 5px;
      
    }
  }
  
}
.scroll-item-wrapper {
}
</style>
